/* eslint-disable react-hooks/exhaustive-deps */
import { FC, useState, useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { useHistory, useParams } from 'react-router-dom'
import { ServerError, useLazyQuery, useMutation } from '@apollo/client'

import { Step1Sub1 } from './Step1Sub1'
import { Step1Sub2 } from './Step1Sub2'
import { Step1Sub3 } from './Step1Sub3'
import Alert from '../../../../_metronic/partials/alert'
import mutations from '../../../../setup/graphql/mutations'
import { fetchStop } from '../../../../redux/actions/common'
import {
  setEntityData,
  setLoanApplication,
  setOpenVerification,
  setPersonData,
  setSubStep,
} from '../redux/actions'
import query from '../../../../setup/graphql/query'
import { Spinner } from 'react-bootstrap-v5'

const Step1: FC = () => {
  const dispatch = useDispatch()
  const history = useHistory()
  const params: any = useParams()
  const { id } = params

  const [showAlert, setShowAlert] = useState<boolean>(false)
  const [alertMsg, setAlertMsg] = useState<string>('')
  const [alertType, setAlertType] = useState<any>('primary')
  const [mobileNo, setMobileNo] = useState('')
  const [showOtp, setShowOtp] = useState(false)

  const subStep = useSelector((state: any) => state.coApplicant.subStep)
  const loanApplication = useSelector((state: any) => state.loan.loanApplication)
  const [sendOTP, onSuccessSendOTP] = useMutation(mutations.SEND_OTP)
  const [validateOTP, onSucccessValidateOTP] = useMutation(mutations.VALIDATE_OTP)
  const [getApplication, onSuccessGetApplication] = useLazyQuery(query.GET_APPLICATION, {
    fetchPolicy: 'network-only', // always go to server
  })
  const [updateApplication] = useMutation(mutations.UPDATE_APPLICATION)

  useEffect(() => {
    if (onSuccessSendOTP.called && !onSuccessSendOTP.loading) {
      dispatch(fetchStop())
      if (onSuccessSendOTP.data) {
        if (onSuccessSendOTP.data.generateOtp.success) {
          localStorage.removeItem('singpass')
          localStorage.setItem('loanApplicationId', onSuccessSendOTP.data.generateOtp.id)
          localStorage.setItem('loanType', onSuccessSendOTP.data.generateOtp.type)
          if (loanApplication && loanApplication?.companyUEN) {
            if (
              ['stage', 'sandbox', 'dev', 'local'].includes(localStorage.getItem('env') as string)
            ) {
              ;(async () => {
                const response = await import(
                  `../../../../utils/custom/${loanApplication.companyUEN}/step3.json`
                )
                const entityData: any = response.default
                if (entityData) {
                  // Dispatch the action to update the loan eligibility in the Redux store
                  dispatch(setEntityData(entityData))
                }
              })()
            }
            localStorage.setItem('companyUEN', loanApplication.companyUEN)
          }
          history.push('/co-applicant-kyb/' + onSuccessSendOTP.data.generateOtp.id)
          dispatch(setSubStep(2))
          setShowOtp(true)
          dispatch(setOpenVerification(false))
          onSuccessSendOTP.reset()
        } else {
          setShowAlert(true)
          setAlertMsg(
            'eKYB is already verified using the link or the input mobile number does not match. Please verify and try again.'
          )
          setAlertType('primary')
          dispatch(fetchStop())
        }
      }

      if (onSuccessSendOTP.error) {
        const { networkError } = onSuccessSendOTP.error
        let errorList = 'ERROR: '
        if (networkError && (networkError as ServerError)) {
          errorList =
            errorList +
            (networkError as ServerError as any).result.errors
              .map((error: any) => error.message)
              .join(', ')
        }
        setShowAlert(true)
        setAlertMsg(errorList)
        setAlertType('primary')
        dispatch(fetchStop())
      }
    }
  }, [
    onSuccessSendOTP.loading,
    onSuccessSendOTP.data,
    onSuccessSendOTP.error,
    onSuccessSendOTP.called,
  ])
  useEffect(() => {
    if (loanApplication == null) {
      getApplication({
        variables: {
          appId: id,
        },
      })
      dispatch(setOpenVerification(false))
    }
  }, [])

  useEffect(() => {
    if (onSucccessValidateOTP.called && !onSucccessValidateOTP.loading) {
      dispatch(fetchStop())
      if (onSucccessValidateOTP.data) {
        if (onSucccessValidateOTP.data.validateOtp.success) {
          if (loanApplication == null) {
            getApplication({ variables: { appId: id } })
          } else {
            setShowOtp(false)
            dispatch(setOpenVerification(true))
          }

          onSucccessValidateOTP.reset()
        } else {
          const message = onSucccessValidateOTP.data.validateOtp.message
          setShowAlert(true)
          setAlertMsg(message)
          setAlertType('primary')
        }
      }

      if (onSucccessValidateOTP.error) {
        const { networkError } = onSucccessValidateOTP.error
        let errorList = 'ERROR: '
        if (networkError && (networkError as ServerError)) {
          errorList =
            errorList +
            (networkError as ServerError as any).result.errors
              .map((error: any) => error.message)
              .join(', ')
        }
        setShowAlert(true)
        setAlertMsg(errorList)
        setAlertType('primary')
      }
    }
  }, [
    onSucccessValidateOTP.loading,
    onSucccessValidateOTP.data,
    onSucccessValidateOTP.error,
    onSucccessValidateOTP.called,
  ])

  useEffect(() => {
    if (onSuccessGetApplication.data && !onSuccessGetApplication.error) {
      const { getLatestApplication } = onSuccessGetApplication.data
      dispatch(fetchStop())
      if (subStep !== 3) dispatch(setOpenVerification(true))
      dispatch(setLoanApplication(getLatestApplication))
      if (getLatestApplication?.agentCode) {
        localStorage.setItem('agentCode', getLatestApplication?.agentCode)
      }
      if (['stage', 'sandbox', 'dev', 'local'].includes(localStorage.getItem('env') as string)) {
        ;(async () => {
          if (getLatestApplication && getLatestApplication.companyUEN) {
            const response = await import(
              `../../../../utils/custom/${getLatestApplication?.companyUEN}/step3.json`
            )
            const eligibilityData: any = response.default
            if (eligibilityData) {
              // Dispatch the action to update the loan eligibility in the Redux store
              dispatch(setPersonData(eligibilityData))
            }
          }
        })()
      }
    }
  }, [onSuccessGetApplication.data, onSuccessGetApplication.error, onSuccessGetApplication.loading])

  const handleCloseOtp = () => {
    setShowOtp(false)
    dispatch(setSubStep(1))
  }

  return (
    <>
      {subStep === 1 && onSuccessGetApplication?.data?.getLatestApplication && (
        <Step1Sub1
          sendOTP={sendOTP}
          setMobile={setMobileNo}
          id={id}
          name={
            onSuccessGetApplication?.data?.getLatestApplication?.applicantName ||
            loanApplication?.applicantName
          }
          mobile={
            onSuccessGetApplication?.data?.getLatestApplication?.agentKybMail?.mobileNumber ||
            loanApplication?.mobileNumber
          }
        />
      )}
      {subStep === 2 && (
        <>
          <Step1Sub2
            mobileNo={mobileNo}
            sendOTP={sendOTP}
            validateOTP={validateOTP}
            id={id}
            show={showOtp}
            handleClose={handleCloseOtp}
          />
          {/* <Step1Sub1
            sendOTP={sendOTP}
            setMobile={setMobileNo}
            id={id}
            name={onSuccessGetCoApplicant?.data?.getShareHolderById?.personName}
            mobile={onSuccessGetCoApplicant?.data?.getShareHolderById?.corppasMobileNumber}
          /> */}
          <div
            style={{
              display: 'flex',
              justifyContent: 'center',
              alignItems: 'center',
              height: '100%',
              minHeight: '100vh',
              background: 'rgba(255,255,255,0.3)',
              zIndex: 99,
              position: 'fixed',
              width: '100%',
              left: 0,
              top: 0,
            }}
          >
            <Spinner
              style={{
                height: '4rem',
                width: '4rem',
              }}
              animation='grow'
              variant='danger'
            />
          </div>
        </>
      )}
      {subStep === 3 && (
        <Step1Sub3 updateApplication={updateApplication} getApplication={getApplication} />
      )}
      {/* {subStep === 4 && <Step1Sub4 {...additionalProps} />} */}

      {showAlert && (
        <Alert variant={alertType} showAlert={showAlert} setShowAlert={setShowAlert}>
          {alertMsg}
        </Alert>
      )}
    </>
  )
}

export { Step1 }
